import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  backdrop: {
    zIndex: 9999,
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.light,
  },
  pricing__main_top: {
    display: "flex",
    flexDirection: "column",
    padding: "10px",
  },
  pricing_top: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  subscription_intro_text: {
    fontSize: "15px",
    lineHeight: "24px",
    fontWeight: "400",
    color: "black",
  },
  subscription_text: {
    fontSize: "20px",
    lineHeight: "24px",
    fontWeight: "600",
    color: "black",
  },
  subscription_btn: {
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: "500",
    padding: "10px 15px",
    backgroundColor: "#4d1277",
    color: "white",
    "&:hover": {
      backgroundColor: "#4d1277",
      color: "white",
    },
  },
  main_container: {
    maxWidth: "1440px",
    width: "100%",
    padding: "20px",
    margin: "auto",
  },
  flexContainer: {
    display: "flex",
    gap: "20px",
    "&>div": { flex: 1 },
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  pricing_container: {
    // marginTop: "7rem !important",
    maxWidth: "80%",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
  },
  settingsWidth: {
    maxWidth: "98%",
  },
  subscribe_text: {
    lineHeight: "21px",
    letterSpacing: "0",
    fontSize: "14px",
    fontWeight: "400",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#ffe5e5",
    padding: "1rem",
    borderRadius: "12px",
  },
  subscribe_icon: {
    marginRight: "10px",
    color: "red",
  },
  businessMarketingText: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "10px",
    color: "#999999",
  },
  plan_container: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
    gap: "20px",
    marginTop: "20px",
  },

  package_container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignContent: "flex-start",
    //
    height: "auto",
    flex: 1,
    boxShadow: "0px 0px 14px 0px #00000026",
    //
    backgroundColor: "white",
    fontSize: "14px",
    lineHeight: "22px",
    color: "var(--content-basic-primary)",
    padding: "24px 20px 33px",
    position: "relative",
    boxSizing: "border-box",

    borderRadius: "15px",
  },
  package_container_header_container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  package_container_plan: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "14px",
    color: "#4D1277",
  },
  package_container_name: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "20px",
    color: "#272525",
    textAlign: "left",
  },
  package_container_description: {
    marginBottom: "20px",
    //
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "16px",
    //
    color: "#999999",
  },
  package_container_pricing_container: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    color: "#4D1277",
  },
  package_container_pricing_figure: {
    display: "flex",
    justifyContent: "flex-start",
    alignContent: "flex-end",
    //
    fontWeight: "800",
    fontSize: "40px",
    marginRight: "10px",
    lineHeight: "100%",
  },
  enterprisePackage: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "5px",
  },
  enterpriseIcon: {
    width: "45px",
    height: "45px",
  },
  package_container_pricing_figure_dollar: {
    alignSelf: "flex-end",
    height: "auto",
    //
    fontFamily: "Poppins",
    fontWeight: "700",
    fontSize: "20px",
    lineHeight: "normal",
  },
  perUserText: {
    fontSize: "12px",
    color: "#635f5f",
  },
  package_container_btn: {
    fontFamily: "Poppins",
    padding: "11px 14px",
    borderRadius: "6px",
    //
    backgroundColor: "white",
    color: "#4d1277",
    //
    transitionDuration: ".2s",
    transitionProperty: "border,color,background-color",
    transitionTimingFunction: "cubic-bezier(.64,0,.35,1)",
    border: "2px solid #4d1277",
    cursor: "pointer",
    textAlign: "center",
    textDecoration: "none",
    fontWeight: "500",
    fontSize: "16px",
    textTransform: "capitalize",
    //
    margin: "20px 0",
    "&:hover": {
      backgroundColor: "#4d1277 !important",
      color: "white",
    },
  },
  package_container_btn_active: {
    backgroundColor: "#4d1277 !important",
    color: "white",
  },
  featuresHeadText: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "22px",
    color: "#272525",
  },
  package_container_features: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  package_container_features_text: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "3px",
    fontWeight: "400",
    fontSize: "10px",
    color: "#272525",
    padding: "4px 0px",
  },
  package_container_features_icon: {
    width: "15px",
    height: "15px",
    lineHeight: "10px",
    marginRight: "4px",
    backgroundColor: "#e6d9ec",
    borderRadius: "50%",
    color: "#4d1277",
    border: "1px solid #4d1277",
  },
  selectorGroup: {
    display: "flex",
    flexDirection: "column",
  },
  plan_text: {
    fontSize: "20px",
    lineHeight: "24px",
    fontWeight: "600",
    color: "black",
  },
  progressIndicator: {
    marginTop: "5px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
}));

export default useStyles;
